import { render, staticRenderFns } from "./OMultiCheckbox.vue?vue&type=template&id=8a5a5516&scoped=true&"
import script from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./OMultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./OMultiCheckbox.vue?vue&type=style&index=0&id=8a5a5516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5a5516",
  null
  
)

export default component.exports